import type { ISubscription } from './types';

import request from 'superagent';
import { gql } from '@apollo/client';

import { dispatch } from 'src/state';
import { hideDialog } from 'src/state/ui/actions';
// graphql
import { apolloClient } from 'src/lib/apollo-client';
// types
import {
  STRIPE_INVOICE_REQUEST,
  STRIPE_INVOICE_SUCCESS,
  STRIPE_INVOICE_FAILURE,
  SUBSCRIPTION_GET_FAILURE,
  SUBSCRIPTION_GET_REQUEST,
  SUBSCRIPTION_GET_SUCCESS,
  SUBSCRIPTION_LINK_REQUEST,
  SUBSCRIPTION_LINK_SUCCESS,
  SUBSCRIPTION_LINK_FAILURE,
  SUBSCRIPTION_CANCEL_REQUEST,
  SUBSCRIPTION_CANCEL_SUCCESS,
  SUBSCRIPTION_CANCEL_FAILURE,
  SUBSCRIPTION_RESUME_REQUEST,
  SUBSCRIPTION_RESUME_SUCCESS,
  SUBSCRIPTION_RESUME_FAILURE,
  SUBSCRIPTION_UNLINK_FAILURE,
  SUBSCRIPTION_UNLINK_REQUEST,
  SUBSCRIPTION_UNLINK_SUCCESS,
  SUBSCRIPTION_TOGGLE_INTERVAL,
  SUBSCRIPTION_DATAPOPUPCLOSED,
} from 'src/state/action-types';

import { SubscriptionFragment } from './types';

export function dataPopupClosed(id?: string, reference?: string) {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_DATAPOPUPCLOSED,
      payload: {
        id,
        reference,
      },
    });

    // Close the subscription dialog
    dispatch(hideDialog('subscription'));

    setTimeout(() => {
      dispatch(getSubscription());
    }, 1000);
  };
}
export function toggleDisplayInterval() {
  return {
    type: SUBSCRIPTION_TOGGLE_INTERVAL,
  };
}

export function getSubscription() {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_GET_REQUEST,
    });

    try {
      const { data } = await apolloClient.query<{
        me: {
          subscription: ISubscription;
        };
      }>({
        query: gql`
          query getSubscription {
            me {
              subscription {
                ...SubscriptionFragment
              }
            }
          }
          ${SubscriptionFragment}
        `,
        fetchPolicy: 'network-only',
      });

      dispatch({
        type: SUBSCRIPTION_GET_SUCCESS,
        payload: {
          subscription: data?.me.subscription,
        },
      });
    } catch (error) {
      dispatch({
        type: SUBSCRIPTION_GET_FAILURE,
        payload: error,
      });
    }
  };
}

export function cancelSubscription() {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_CANCEL_REQUEST,
    });

    try {
      const { data } = await apolloClient.mutate<any>({
        mutation: gql`
          mutation cancelSubscription {
            cancelSubscription {
              ...SubscriptionFragment
            }
          }
          ${SubscriptionFragment}
        `,
      });

      dispatch({
        type: SUBSCRIPTION_CANCEL_SUCCESS,
        payload: {
          subscription: data?.cancelSubscription,
        },
      });
    } catch (error) {
      dispatch({
        type: SUBSCRIPTION_CANCEL_FAILURE,
        payload: error,
      });
    }
  };
}

export function resumeSubscription() {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_RESUME_REQUEST,
    });

    try {
      const { data } = await apolloClient.mutate<any>({
        mutation: gql`
          mutation resumeSubscription {
            resumeSubscription {
              ...SubscriptionFragment
            }
          }
          ${SubscriptionFragment}
        `,
      });

      dispatch({
        type: SUBSCRIPTION_RESUME_SUCCESS,
        payload: {
          subscription: data?.resumeSubscription,
        },
      });
    } catch (error) {
      dispatch({
        type: SUBSCRIPTION_RESUME_FAILURE,
        payload: error,
      });
    }
  };
}

export function linkSubscription(subscriptionId: string): any {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_LINK_REQUEST,
      payload: {
        subscriptionId,
      },
    });

    try {
      await request
        .post(`/api/v1/user/subscription/link`)
        .withCredentials()
        .send({ subscriptionId });

      dispatch({
        type: SUBSCRIPTION_LINK_SUCCESS,
        payload: {
          subscriptionId,
        },
      });

      dispatch(getSubscription());
    } catch (error: any) {
      dispatch({
        type: SUBSCRIPTION_LINK_FAILURE,
        errorCode: error.response.body.code,
      });
    }
  };
}

export function unlinkSubscription(subscriptionId: string): any {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_UNLINK_REQUEST,
      payload: {
        subscriptionId,
      },
    });

    try {
      await request
        .delete(`/api/v1/user/subscription/link`)
        .withCredentials()
        .send({ subscriptionId });

      dispatch({
        type: SUBSCRIPTION_UNLINK_SUCCESS,
        payload: {
          subscriptionId,
        },
      });
    } catch (error) {
      dispatch({
        type: SUBSCRIPTION_UNLINK_FAILURE,
        payload: error,
      });
    }
  };
}

export function openSubscriptionCheckout(user: {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}) {
  return () => {
    if ((window as any).fastspring && (window as any).fastspring.builder) {
      (window as any).fastspring?.builder?.reset();
      (window as any).fastspring?.builder?.add('pro');
      (window as any).fastspring?.builder?.tag({ userId: user.id });
      (window as any).fastspring?.builder?.recognize({
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        userId: user.id,
      });
      (window as any).fastspring?.builder?.checkout();
    }
  };
}

// function getUcc(): string | null {
//   const _uccRaw =
//     typeof window.CelloAttribution === 'function' ? window.CelloAttribution('getUcc') : null;
//   const fromCello = typeof _uccRaw === 'string' && _uccRaw ? _uccRaw : null;
//   return fromCello || localStorage.getItem('cello_ucc');
// }

export function createStripeCheckoutSession(plan: 'pro' | 'pro-yearly') {
  return async () => {
    try {
      //   const ucc = getUcc();

      const { data } = await apolloClient.mutate<{
        createSubscriptionCheckoutSession: { url: string; sessionId: string };
      }>({
        mutation: gql`
          mutation CreateSubscriptionCheckoutSession(
            $plan: String!
            $successUrl: String!
            $cancelUrl: String!
            $ucc: String
          ) {
            createSubscriptionCheckoutSession(
              plan: $plan
              successUrl: $successUrl
              cancelUrl: $cancelUrl
              ucc: $ucc
            ) {
              url
              sessionId
            }
          }
        `,
        variables: {
          plan,
          successUrl: `${window.location.origin}/dashboard/user/account/subscription?success=true`,
          cancelUrl: `${window.location.origin}/dashboard/user/account/subscription`,
          //   ucc: ucc || undefined,
        },
      });

      if (data?.createSubscriptionCheckoutSession.url) {
        window.location.href = data.createSubscriptionCheckoutSession.url;
      }
    } catch (error) {
      console.error('Failed to create checkout session:', error);
    }
  };
}

export function createStripePortalSession() {
  return async () => {
    try {
      const { data } = await apolloClient.mutate<{
        createStripePortalSession: string;
      }>({
        mutation: gql`
          mutation CreateStripePortalSession {
            createStripePortalSession
          }
        `,
      });

      if (data?.createStripePortalSession) {
        window.location.href = data.createStripePortalSession;
      }
    } catch (error) {
      console.error('Failed to create portal session:', error);
    }
  };
}

export function createStripeInvoice() {
  return async () => {
    dispatch({ type: STRIPE_INVOICE_REQUEST });
    try {
      //   const ucc = getUcc();

      const { data } = await apolloClient.mutate<{
        createStripeInvoice: string;
      }>({
        mutation: gql`
          mutation CreateStripeInvoice($ucc: String) {
            createStripeInvoice(ucc: $ucc)
          }
        `,
        // variables: { ucc: ucc || undefined }
      });

      const invoiceUrl = data?.createStripeInvoice;
      dispatch({
        type: STRIPE_INVOICE_SUCCESS,
        payload: { invoiceUrl: invoiceUrl ?? '' },
      });

      if (invoiceUrl) {
        window.open(invoiceUrl, '_blank');
      }
    } catch (error) {
      dispatch({ type: STRIPE_INVOICE_FAILURE, payload: error as Error });
    }
  };
}

export function unlinkStripeSubscription() {
  return async () => {
    dispatch({
      type: SUBSCRIPTION_UNLINK_REQUEST,
      payload: { subscriptionId: '' },
    });
    try {
      await apolloClient.mutate({
        mutation: gql`
          mutation UnlinkStripeSubscription {
            unlinkStripeSubscription
          }
        `,
      });
      dispatch({
        type: SUBSCRIPTION_UNLINK_SUCCESS,
        payload: { subscriptionId: '' },
      });
      dispatch(getSubscription());
    } catch (error) {
      dispatch({
        type: SUBSCRIPTION_UNLINK_FAILURE,
        errorCode: (error as any)?.message ?? 'unknown',
      });
    }
  };
}
